import React from 'react';


export const Footer = () => {

    return(
        <div className="footer-holder">
            <div className="footer-section-holder">
                <div className="footer-link-holder">
                    <a href="https://infinitbot.com/terms" rel="noopener noreferrer" target="_blank" className="footer-link">Terms & Conditions</a>
                </div>
                <div className="footer-link-holder">
                    <a href="https://infinitbot.com/privacy" rel="noopener noreferrer" target="_blank" className="footer-link">Privacy Policy</a>   
                </div>
            </div>
            <div className="footer-copyright-holder">
                <h4 className="footer-text">Copyright © 2022 Infinit. All Rights Reserved.</h4>
            </div>
            <div className="footer-section-holder">
                <div className="footer-email-holder">
                    <h4 className="footer-text">info@infinitbot.com</h4>
                </div>
                <div className="footer-link-holder">
                    <a href="https://infinitbot.com" rel="noopener noreferrer" target="_blank" className="footer-link">infinitbot.com</a>
                </div>
            </div>
        </div>
    )
}
